import CustomList from './custom-list.vue';
export default CustomList;
